import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./sitePages.css";
import useScrollReveal from "./useScrollReveal";
import pmeImage from "./Images/Pme.avif";

function PMESolutions({ embedded = false }) {
  useScrollReveal();
  return (
    <div className="content-page">
      {!embedded && <Header />}

      <main className="content-main">
        <section className="page-hero page-hero-split">
          <div className="page-hero-copy">
            <h1>Solutions pour PME</h1>
            <p>
              Une offre pragmatique pour fiabiliser votre IT, s&eacute;curiser
              vos donn&eacute;es et digitaliser vos op&eacute;rations.
            </p>
          </div>
          <div className="page-hero-media reveal-on-scroll" data-reveal>
            <img
              src={pmeImage}
              alt="PME equipee pour la performance et la transformation numerique"
              loading="lazy"
            />
          </div>
        </section>

        <section className="content-grid">
          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>Infrastructure IT</h3>
            <p>
              Audit, conception et d&eacute;ploiement d&apos;une infrastructure
              adapt&eacute;e &agrave; la croissance de votre activit&eacute;.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>S&eacute;curisation des donn&eacute;es</h3>
            <p>
              Protection des acc&egrave;s, sauvegardes, plan de reprise et bonnes
              pratiques de cybers&eacute;curit&eacute;.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>Applications internes</h3>
            <p>
              Outils m&eacute;tier sur mesure pour automatiser les processus
              critiques et gagner en productivit&eacute;.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>Support technique</h3>
            <p>
              Assistance de proximit&eacute;, maintenance pr&eacute;ventive et
              corrective pour garantir la continuit&eacute; de service.
            </p>
          </article>
        </section>
      </main>

      {!embedded && <Footer />}
    </div>
  );
}

export default PMESolutions;
